





















import Vue from 'vue'
import SearchForm from '@/components/sub-components/SearchForm.vue'
import PeriodMonthSelector from '@/components/sub-components/PeriodMonthSelector.vue'
import { buildMonthPeriod, withSingularOrPluralLabel } from '@/utils/labels'
import moment from 'moment-timezone'
import {
  ActionNames as SiteStatsActionNames,
  GetterNames as SiteStatsGetterNames,
} from '@/store/modules/site-stats/keys'
import { OFFSET_HOURS_TIMESTAMP } from '@/components/patient-stats/graphs/mapping-chart-options/constants'
import { mapActions, mapGetters } from 'vuex'
import { ModuleNames } from '@/store/module-names'

const monthLabels = ['MONTH', 'MONTHS']
export default Vue.extend({
  components: {
    SearchForm,
    PeriodMonthSelector,
  },
  props: {
    includeSearch: {
      type: Boolean,
      default: true,
    },
    // filters: {
    //   type: Array,
    //   default: () => [],
    // },
    // selectedFilter: {
    //   type: Object,
    //   default: () => ({}),
    // },
    // selectedPeriod: {
    //   type: Object,
    //   default: () => ({}),
    // },
    searchText: {
      type: String,
      required: true,
    },
    wholeMonths: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectedPeriod: null,
      displayMonths: 0,
      periodOptions: [
        buildMonthPeriod(0, true),
        buildMonthPeriod(1, true),
        buildMonthPeriod(2, true),
        buildMonthPeriod(3, true),
        buildMonthPeriod(4, true),
        buildMonthPeriod(5, true),
        buildMonthPeriod(6, true),
        buildMonthPeriod(7, true),
        buildMonthPeriod(8, true),
        buildMonthPeriod(9, true),
        buildMonthPeriod(10, true),
        buildMonthPeriod(11, true),
        buildMonthPeriod(12, true),

        // { months: 1, label: withSingularOrPluralLabel(1, monthLabels[0], monthLabels[1]) },
        // { months: 2, label: withSingularOrPluralLabel(2, monthLabels[0], monthLabels[1]) },
        // { months: 3, label: withSingularOrPluralLabel(3, monthLabels[0], monthLabels[1]) },
        // { months: 4, label: withSingularOrPluralLabel(4, monthLabels[0], monthLabels[1]) },
        // { months: 5, label: withSingularOrPluralLabel(5, monthLabels[0], monthLabels[1]) },
        // { months: 6, label: withSingularOrPluralLabel(6, monthLabels[0], monthLabels[1]) },
        // { months: 7, label: withSingularOrPluralLabel(7, monthLabels[0], monthLabels[1]) },
        // { months: 8, label: withSingularOrPluralLabel(8, monthLabels[0], monthLabels[1]) },
        // { months: 9, label: withSingularOrPluralLabel(9, monthLabels[0], monthLabels[1]) },
        // { months: 10, label: withSingularOrPluralLabel(10, monthLabels[0], monthLabels[1]) },
        // { months: 11, label: withSingularOrPluralLabel(11, monthLabels[0], monthLabels[1]) },
        // { months: 12, label: withSingularOrPluralLabel(12, monthLabels[0], monthLabels[1]) },
      ],
    }
  },
  computed: {
    ...mapGetters({
      siteStats: `${ModuleNames.siteStats}/${SiteStatsGetterNames.siteStatses}`,
    }),
    ...mapGetters(ModuleNames.siteStats, [SiteStatsGetterNames.siteStatses]),

    startTimestamp() {
      if (this.displayWeeks === Infinity) return 1
      let start = moment(this.endTimestamp)
      if (this.wholeMonths) {
        start = start
          .startOf('month')
          .add(this.displayMonths * -1, 'months')
          .startOf('day')
      } else {
        start = start
          .utc()
          .add(this.displayMonths * -1, 'months')
          .add(1, 'day')
          .startOf('day')
      }

      return start.valueOf()
    },
    endTimestamp() {
      // now
      const end = moment()
        .utc()
        .endOf('day')
      return end.valueOf()
    },
  },
  methods: {
    ...mapActions(ModuleNames.siteStats, [SiteStatsActionNames.getSiteStatses]),
    loadSiteStats() {
      const lastYearTimestamp = moment()
        .add(-1, 'y')
        .startOf('month')
        .startOf('day')
        .valueOf()
      this[SiteStatsActionNames.getSiteStatses]({
        startTimestamp: Math.max(lastYearTimestamp, this.startTimestamp),
        endTimestamp: this.endTimestamp,
      })
    },
    async selectPeriod(option): Promise<void> {
      this.selectedPeriod = option
      this.displayMonths = option.months

      this.$emit('loadSiteStats', {
        startTimestamp: this.startTimestamp,
        endTimestamp: this.endTimestamp,
      })
      // await this.loadSiteStats()
      // this.$emit('loadChange', { isLoading: false })
    },
  },
})
